import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { IParentInterview } from '../models/parentInterview';


@Injectable({
  providedIn: 'root'
})
export class ParentInterviewService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getParentInterviewByCaseId(caseId: string): Observable<IParentInterview> {
        const url = environment.apiBaseUrl + endpoints.getParentInterviewByCaseId.replace(':caseId', caseId);
        return this.http.get<IParentInterview>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateParentInterview(data: IParentInterview): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.updateParentInterview;
        return this.http.post(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }
}